import React from "react";
import "./Info.css";

const Info = () => {
  return (
    <div className="Info-Container" id="Info">
      <div className="Info-header">
        <p className="Info-Title">What is Black Lit Network?</p>
      </div>
      <div className="Info-Content">
        <div className="Info-Img-div">
          <div className="image-container">
            <img src="BlackLit1.png" alt="Study Black Writing"></img>
            <p>Studying Black Writing</p>
          </div>
          <div className="image-container">
            <img src="BlackLit2.png" alt="7,000 Black novels and memoirs"></img>
            <p>7,000 Black novels and memoirs</p>
          </div>
          <div className="image-container">
            <img src="BlackLit3.png" alt="Support research and learning"></img>
            <p>Support research and learning</p>
          </div>
        </div>

        <p id="info-top-desc">
          Portals making ideas about African American novels and collections
          available through a podcast, visualizations, briefs, and interactive
          search engines.
        </p>
      </div>
      <div className="Info-header">
        <p className="Info-Title">How can I use this website?</p>
      </div>
      <div className="Info-Content-Bottom">
        <div className="InfoPanel2">
          <img src="/Frame116.png" alt="Listen to Podcasts"></img>
          <img src="/Frame117.png" alt="View data visualizations"></img>
          <img src="/Frame118.png" alt="Read brief write-ups"></img>
        </div>
        <p id="info-bottom-desc">
          BLN is designed to make information and ideas about African American
          novels widely available. The portals for the Network address several
          basic yet enduring questions: What’s a good African American novel to
          read? What’s the story behind the publication of some famous novels by
          black writers? What’s the relationship of one novel to dozens of other
          novels? What key terms assist us in understanding the works of black
          writers?
        </p>
      </div>
    </div>
  );
};

export default Info;
